import {
  Box,
  IconButton,
  LinearProgress,
  linearProgressClasses,
  LinearProgressProps,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material'
import React, { useCallback } from 'react'
import { styled } from '@mui/material/styles'

export interface ISuccessSnackbarProps {
  open: boolean
  children: string | string[] | JSX.Element
  onClose: () => void
  autoHideDuration?: number
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 4,
  borderBottomLeftRadius: '4px',
  borderBottomRightRadius: '4px',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#DCDDDE',
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: '#61C666',
  },
}))

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number }
) {
  return <BorderLinearProgress variant="determinate" {...props} />
}

const SuccessSnackbar = ({
  open,
  onClose,
  children,
  autoHideDuration = 4000,
}: ISuccessSnackbarProps) => {
  const [progress, setProgress] = React.useState(100)
  let timer: NodeJS.Timer

  const clearIntervalTimer = useCallback(() => {
    if (timer) clearInterval(timer)
  }, [])

  function initProgress() {
    if (open) {
      clearIntervalTimer()
      timer = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress <= 0) {
            clearIntervalTimer()
            setTimeout(onClose, 500)
            setTimeout(() => setProgress(100), 1000)
            return 0
          }
          return prevProgress - 100 / (autoHideDuration / 50)
        })
      }, 50)
    }
  }

  React.useEffect(() => {
    return () => {
      clearIntervalTimer()
    }
  }, [])

  React.useEffect(() => {
    initProgress()
  }, [open])

  return (
    <Snackbar
      open={open}
      //autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box sx={{ backgroundColor: 'white', borderRadius: '4px' }}>
        <Stack direction="row" spacing={1} sx={{ p: 1 }} alignItems="center">
          <Box width="40px" height="40px">
            <img
              src="/assets/messages/success.svg"
              alt="success"
              loading="lazy"
            />
          </Box>
          <Typography
            fontWeight={600}
            fontSize="16px"
            lineHeight="20px"
            color="#343948"
          >
            {children}
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <img src="/assets/messages/close.svg" alt="close" loading="lazy" />
          </IconButton>
        </Stack>
        <LinearProgressWithLabel value={progress} />
      </Box>
    </Snackbar>
  )
}

export default SuccessSnackbar
